import { useState, useEffect } from 'react';
import { useMoanaPaye } from '../../contexts/MoanaPayeContext';
import { Building2, Users, FileText, TrendingUp } from 'lucide-react';

export default function MoanaPayeDashboard() {
  const { mpFetch } = useMoanaPaye();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    mpFetch('/api/moana-paye/dashboard').then(setStats).catch(console.error);
  }, []);

  const cards = [
    { label: 'Entreprises', value: stats?.nb_entreprises ?? '-', icon: Building2, color: '#2D5A5A' },
    { label: 'Salaries actifs', value: stats?.nb_salaries ?? '-', icon: Users, color: '#E8A020' },
    { label: 'CDD actifs', value: stats?.nb_cdd_actifs ?? '-', icon: FileText, color: '#6366f1' },
  ];

  return (
    <div data-testid="mp-dashboard">
      <h2 className="text-xl font-bold text-white mb-6">Tableau de bord</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {cards.map(c => (
          <div key={c.label} className="bg-[#1a2332] border border-white/10 rounded-xl p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="text-slate-400 text-sm">{c.label}</span>
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: c.color + '20' }}>
                <c.icon className="w-4.5 h-4.5" style={{ color: c.color }} />
              </div>
            </div>
            <div className="text-2xl font-bold text-white">{c.value}</div>
          </div>
        ))}
      </div>
      <div className="bg-[#1a2332] border border-white/10 rounded-xl p-5">
        <h3 className="text-white font-semibold mb-3 text-sm">Actions rapides</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {[
            { label: 'Nouvelle entreprise', href: '/moana-paye/entreprises?new=1' },
            { label: 'Nouveau salarie', href: '/moana-paye/salaries?new=1' },
            { label: 'Paramètres sociaux', href: '/moana-paye/parametres' },
          ].map(a => (
            <a key={a.label} href={a.href} className="bg-white/5 hover:bg-[#2D5A5A]/30 border border-white/10 rounded-lg px-4 py-3 text-sm text-slate-300 hover:text-white transition-colors text-center">
              {a.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
